import { siteCall } from "../utils/WebCall";
import urls from '../utils/urls';
import { getCurrentUser } from "./UserService"
import moment from "moment";
import { listCalendarMeetings } from "../functions";
import { LIMIT } from '../../src/config/Constants'

export const createUserCalendarMeetings = async(user_id, params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.user_calendar_meetings_url + "/create",
        method: "POST",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const updateUserCalendarMeetings = async(user_id, calendar_meeting_id, params, successCallback, errorCallback) => {
    return siteCall({
        url: urls.user_calendar_meetings_url + "/update/" + calendar_meeting_id,
        method: "PUT",
        body: JSON.stringify(params),
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const partialUpdateUserCalendarMeetings = async(user_id, calendar_meeting_id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_calendar_meetings_url + "/partial-update/" + calendar_meeting_id,
      method: "PATCH",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const deleteUserCalendarMeetings = async(user_id, calendar_meeting_id, successCallback, errorCallback) => {
    return siteCall({
        url: urls.user_calendar_meetings_url + "/delete/" + calendar_meeting_id,
        method: "DELETE",
        body: {},
        successCallback: successCallback,
        errorCallback: errorCallback,
      });
}


export const getUserCalendarMeetings = async(user_id, calendar_meeting_id, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_calendar_meetings_url + "/get/" + calendar_meeting_id,
      method: "GET",
      body: {},
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getAllUserCalendarMeetings = async(user_id, params, successCallback, errorCallback) => {
  let filters = params.filters || {};
  filters["meetingPlatform"] = {"not-in": [""]}
  params.filters = filters;
  return siteCall({
      url: urls.user_calendar_meetings_url + `/get-all`,
      method: "POST",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const getAllCalendarBotMeetings = async(user_id, params, successCallback, errorCallback) => {
  return siteCall({
      url: urls.user_calendar_meetings_url + `/bot-meetings/get-all`,
      method: "POST",
      body: JSON.stringify(params),
      successCallback: successCallback,
      errorCallback: errorCallback,
    });
}


export const fetchCalendarImportantMeetings = async (dispatch, page, limit, filters) => {
  page = page || 0;
  limit = limit || LIMIT;
  filters = filters || {};
  filters["favourite"] = true;
  
  let user = getCurrentUser();
  return await getAllUserCalendarMeetings(user.uid, {
    "order_by": "createdAt", "order": "desc", "page": page, "limit": limit,
    "filters": filters
  },
    (response) => {
      let data = response.data;
      let records = data.records;
      import("../redux/actions/meetingsActions").then((ac) =>
        dispatch(ac.setCalendarMeetings(records))
      );
      return data;
    },
    (error) => {
        console.log("error: ", error);
        return [];
    }
  )
};


export const fetchCalendarBotMeetings = async (dispatch, page, limit, filters) => {
  page = page || 0;
  limit = limit || LIMIT;
  filters = filters || {};
  filters["favourite"] = true;

  console.log("fetchCalendarBotMeetings called to store data in setCalendarBotMeetings")
  let user = getCurrentUser();
  return await getAllCalendarBotMeetings(user.uid, {
    "order_by": "createdAt", "order": "desc", "page": page, "limit": limit,
    "filters": filters
  },
    (response) => {
      let data = response.data;
      let records = data.records;
      import("../redux/actions/meetingsActions").then((ac) =>
        dispatch(ac.setCalendarBotMeetings(records))
      );
      return data;
    },
    (error) => {
        console.log("error: ", error);
        return [];
    }
  )
};

export const fetchCalendarMeetings = async (dispatch, page, limit, filters, order_by, order) => {
  page = page || 0;
  limit = limit || LIMIT;
  filters = filters || {};
  order_by = order_by || "endTime";
  order = order || "desc";
  console.log("fetchCalendarMeetings called to store data in setCalendarMeetings")
  let user = getCurrentUser();
  return await getAllUserCalendarMeetings(user.uid, { "order_by": order_by, "order": order, "page": page, "limit": limit,
    "filters": filters
  },
    (response) => {
      let data = response.data;
      let records = data.records;
      import("../redux/actions/meetingsActions").then((ac) =>
        dispatch(ac.setCalendarMeetings(records))
      );
      return data;
    },
    (error) => {
        console.log("error: ", error);
        return [];
    }
  )
};

// const addNewMeetToFirebase = async (newDoc) => {
//   let user = getCurrentUser();
//   return await createUserCalendarMeetings(user.uid, newDoc);
// };

export const fetchUpcomingCalendarMeetings = async (dispatch, page, limit) => {
    console.log("fetchUpcomingCalendarMeetings called to store data in setUpcomingCalendarMeetings")
    page = page || 0;
    limit = limit || LIMIT;
    let filters = {"endTime": {">": new Date()}}
    const order_by = "endTime";
    const order =  "asc";
    let user = getCurrentUser();
    return await getAllUserCalendarMeetings(user.uid, { "order_by": order_by, "order": order, "page": page, "limit": limit,
      "filters": filters
    },
      (response) => {
        let data = response.data;
        let records = data.records;
        import("../redux/actions/meetingsActions").then((ac) =>
          dispatch(ac.setUpcomingCalendarMeetings(records))
        );
        return data;
      },
      (error) => {
          console.log("error: ", error);
          return [];
      }
    )
    // let calendarMeetingsResult = await getAllUserCalendarMeetings(user.uid, { "order_by": "createdAt", "order": "desc", "page": page, "limit": limit  },
    //   (response) => {
    //     return response.data;
    //   },
    //   (error) => {
    //       console.log("error: ", error);
    //       return [];
    //   }
    // );
    // let firebaseCalMeets = calendarMeetingsResult.records;
    // // setIsLoading(false);
    // const uploadedMeets = [];
    // firebaseCalMeets?.forEach((docSnap) => {
    //   uploadedMeets.push({ ...docSnap, id: docSnap.id });
    // });
    // // setIsLoading(true);
    // const calendarMeets = await listCalendarMeetings({
    //   user_id: user.uid,
    //   before: moment().add(1, "years").format("YYYY-MM-DD"),
    //   after: moment().format("YYYY-MM-DD"),
    // });
    // // setIsLoading(false);
    // const newArr = [];
    // if (calendarMeets?.detail !== "Invalid token" && calendarMeets !== null) {
    //   import("../redux/actions/appActions").then((ac) =>
    //     dispatch(ac.integrateCalendarPopup(false))
    //   );
    //   for (const calMeet of calendarMeets) {
    //     let meetId = calMeet.id;
    //     let meetUploaded = false;
    //     for (const upload of uploadedMeets) {
    //       // console.log(`${meetId} : ${upload?.calendarMeetId}`)
    //       if (upload?.calendarMeetId === meetId && !meetUploaded) {
    //         meetUploaded = true;
    //     //     //now update attendees list and emails as attendes might not have accepted invite at the time of calendar meet upload to firebase but maybe later on
    //     //     updateExistingMeet(calMeet, upload);
    //         if(calMeet?.meet_invite?.meeting_id){
    //           newArr.push({
    //             ...upload,
    //             attendees: calMeet.attendees,
    //             attendeeEmails: calMeet.attendee_emails,
    //             botId: calMeet.bot_id,
    //             startTime: calMeet.start_time,
    //             endTime: calMeet.end_time,
    //             willRecord: calMeet.will_record,
    //             meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" },
    //             meetingPlatform: calMeet?.meeting_platform || "",
    //           });
    //         }
    //       }
    //     }
    //     if (!meetUploaded) {
    //       console.log("Unuploaded meet found", moment().format("HH:mm:ss"));
    //       let newDoc = {
    //         calendarMeetId: calMeet.id,
    //         willRecord: calMeet.will_record, //have to be updated
    //         startTime: moment(calMeet.start_time).toDate(), //have to be updated
    //         endTime: moment(calMeet.end_time).toDate(), //have to be updated
    //         meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" }, //have to be updated
    //         meetingPlatform: calMeet?.meeting_platform || "",
    //         botId: calMeet.bot_id, //have to be updated
    //         organizerEmail: calMeet.organizer_email,
    //         attendees: calMeet.attendees, //have to be updated
    //         attendeeEmails: calMeet.attendee_emails, //have to be updated
    //         isHostedByMe: calMeet.is_hosted_by_me,
    //         icalUid: calMeet.ical_uid,
    //         createdAt: new Date(),
    //         favourite: false,
    //         hashTag: "#CalendarMeet",
    //         name: calMeet?.title || "",
    //       };
    //       console.log(
    //         "New Cal Meet Found to be added to Firebase(will be added if upcoming)",
    //         newDoc
    //       );
    //       if (
    //         moment().format("YYYYMMDDHHmmss") <
    //         moment(calMeet.end_time).format("YYYYMMDDHHmmss") && newDoc?.meetingPlatform != ""
    //       ) {
    //         addNewMeetToFirebase(newDoc).then((res) => {
    //           console.log(
    //             "New Cal Meet Added Locally",
    //             {
    //               ...newDoc,
    //               id: res.id,
    //               startTime: moment(calMeet.start_time),
    //               endTime: moment(calMeet.end_time),
    //               createdAt: moment(),
    //             },
    //             moment().format("HH:mm:ss")
    //           );
    //           if(calMeet?.meet_invite?.meeting_id){
    //             newArr.push({
    //               ...newDoc,
    //               id: res.id,
    //               startTime: calMeet.start_time,
    //               endTime: calMeet.end_time,
    //               createdAt: moment(),
    //             });
    //           }
    //         });
    //       }
    //     }
    //   }
      // console.log("adding old uploaded meets locally");
      // for (const upload of uploadedMeets) {
      //   //upcoming meetings: if they are mentioned in calendarMeetings then do nothing otherwise delete them because they were deleted by user
      //   if (
      //     moment().format("YYYYMMDDHHmmss") <
      //     moment(moment(upload?.startTime)?.toDate()).format("YYYYMMDDHHmmss")
      //   ) {
      //     let presentInCalMeets = false;
      //     calendarMeets.forEach((calMeet) => {
      //       if (calMeet.id === upload?.calendarMeetId) {
      //         presentInCalMeets = true;
      //       }
      //     });
      //     if (!presentInCalMeets) {
      //       //if it is not an upcoming meeting now-> delete
      //       console.log("upcoming meet not in calmeets so");
      //       let user = getCurrentUser();
      //       deleteUserCalendarMeetings(user.uid, upload.id);
      //       console.log("deleted upcoming meet from firebase");
      //     } else {
      //       //if it is still an upcoming meeting -> add to local array
      //       let uploadPresent = false;
      //       newArr?.forEach((item) => {
      //         if (item?.calendarMeetId === upload?.calendarMeetId)
      //           uploadPresent = true;
      //       });
      //       if (!uploadPresent) newArr.push(upload);
      //       console.log("added upcoming meet from firebase to local array");
      //     }
      //   }
      //   //past meetings: simply add to local array if not already there
      //   else {
      //     let uploadPresent = false;
      //     newArr?.forEach((item) => {
      //       if (item?.calendarMeetId === upload?.calendarMeetId)
      //         uploadPresent = true;
      //     });
      //     if (!uploadPresent) newArr.push(upload);
      //   }
      // }
      // import("../redux/actions/meetingsActions")
      //   .then((ac) => dispatch(ac.setCalendarMeetings(newArr)))
      //   .then(() => {
          // setTimeout(() => {
          //   if (showGreenToaster) {
          //     toast.success("Calendar meets are now up-to-date");
          //   }
          // }, 15000);
        // });
      // return newArr;
    // } else {
      // import("../redux/actions/appActions").then((ac) =>
      //   dispatch(ac.integrateCalendarPopup(true))
      // );
      // import("../redux/actions/meetingsActions").then((ac) =>
      //   dispatch(ac.setCalendarMeetings(calendarMeets))
      // );
      // return calendarMeets;
    // }
  }